import { render, staticRenderFns } from "./itineraryList.vue?vue&type=template&id=2c4ebd81&scoped=true"
import script from "./itineraryList.vue?vue&type=script&lang=js"
export * from "./itineraryList.vue?vue&type=script&lang=js"
import style0 from "./itineraryList.vue?vue&type=style&index=0&id=2c4ebd81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4ebd81",
  null
  
)

export default component.exports